<template>
  <b-row>
    <b-col>
      <template v-if="videos.length === 0 && loading">
        <b-row v-for="(loader, key) in [90, 50, 70, 40, 80]" v-bind:key="key">
          <b-col class="border-top py-2">
            <b-row>
              <b-col md="auto">
                <div class="image-col">
                  <LoadingLine width="100%" height="62px" />
                </div>
              </b-col>
              <b-col>
                <b-row>
                  <b-col>
                    <LoadingLine :width="loader / 2 + '%'" height="19px" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <LoadingLine
                      :width="loader + '%'"
                      :style="{ marginTop: '10px' }"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-row v-for="(video, key) in videos" v-bind:key="key">
          <b-col class="border-top py-2">
            <b-row>
              <b-col md="auto">
                <div class="image-col">
                  <LazyImage
                    :src="`${video.image}_288x162?r=pad`"
                    :width="288"
                    :height="162"
                    :overlay="false"
                  />
                </div>
              </b-col>
              <b-col>
                <b-row>
                  <b-col>
                    <h6>{{ video.title }}</h6>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>{{ video.description }}</b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import LoadingLine from '@/elements/LoadingLine';
import LazyImage from '@/components/LazyImage';
export default {
  name: 'ProgrammVideos',
  props: {
    videos: {
      default: function() {
        return [];
      },
    },
    loading: { default: false },
  },

  components: { LazyImage, LoadingLine },
};
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import '/../theme';

.image-col {
  width: 110px !important;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/elements/ProgrammVideos.vue